import {AfterViewInit, Component, inject, OnInit} from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { NavService } from '../../../../../../_services/_nav.service';
import { ObligacionesVigentes } from '../../../../../../_models/perfil-cliente/obligaciones-vigentes';

@Component({
  selector: 'app-perfil-crezcamos-creditos-firmantes-referencias',
  templateUrl: './perfil-crezcamos-creditos-firmantes-referencias.component.html',
  styleUrls: ['./perfil-crezcamos-creditos-firmantes-referencias.component.scss']
})
export class PerfilCrezcamosCreditosFirmantesReferenciasComponent implements OnInit, AfterViewInit{
  listFirmantes: any[] = [];
  columnasFirmantes: any[];
  row: ObligacionesVigentes;
  activeIndex: boolean = false;

  private config = inject( DynamicDialogConfig );
  private navServicio = inject( NavService );
  private ref = inject( DynamicDialogRef );

  ngOnInit(): void {
    this.row = this.config.data.row;
    this.listFirmantes = this.config.data.row.firmantes;
    this.listFirmantes = this.listFirmantes.map((firmante: any) => {
      firmante.telefonoPrincipal = this.formatearTelefono(firmante.telefonoPrincipal);
      firmante.telefonoSecundario = this.formatearTelefono(firmante.telefonoSecundario);
      if (firmante.referencias && Array.isArray(firmante.referencias)) {
        firmante.referencias = firmante.referencias.map((referencia: any) => {
          referencia.telefono = this.formatearTelefono(referencia.telefono);
          return referencia;
        });
      }    
      return firmante;
    });
    console.log('this.listFirmantes', this.listFirmantes);
    this.cargarTabla();
  }

  ngAfterViewInit(): void {
    this.activeIndex = true;
  }


  async cargarTabla() {
    this.columnasFirmantes = [
      { field: 'vinculacion', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_PARTICIPACION'), sort: false },
      { field: 'nombreCompleto', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_NOMBRE_COMPLETO'), sort: false },
      { field: 'codigoTipoDocumento', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_TIPODOCUMENTO'), sort: false },
      { field: 'numeroDocumento', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_NUMERODOCUMENTO'), sort: false },
      { field: 'parentesco', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_PARENTESTO'), sort: false },
      { field: 'telefonoPrincipal', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_TELEFONO1'), sort: false },
      { field: 'telefonoSecundario', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_TELEFONO2'), sort: false },
      { field: 'direccionDomicilio', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_DIRECCIONHOGAR'), sort: false },
      { field: 'direccionNegocio', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_DIRECCIONNEGOCIO'), sort: false },
      { field: 'ocupacion', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_OCUPACION'), sort: false },
      { field: 'garantiaRespaldo', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_GARANTIA'), sort: false },
      { field: 'causal', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_CAUSAL'), sort: false },
      /*{ field: 'telefono', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_NUMEROTELEFONO'), sort: false },
      { field: 'tipoReferencia', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_TIPOREFERENCIA'), sort: false },
      { field: 'parentescoRelacion', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_PARENTESTORELACION'), sort: false },*/
    ];
  }
  
  formatearTelefono( numero : any ) {
    if (numero.startsWith("3")) {
        return numero.replace(/(\d{3})(\d{3})(\d{4})/, "$1 $2 $3");
    } else {
        return numero.replace(/(\d{4})(\d{4})/, "$1 $2");
    }
  }

  convertirAbreviatura(abreviatura: string): string {
    return abreviatura.split('').join('.').toUpperCase() + '.';
  }

  cerrarModal() {
    this.ref.close();
  }
 }
